import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconCollapse = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 14,
	height: 14,
	viewBox: "0 0 14 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M13.3711 1.30859L9.65234 5H12.0312C12.3867 5 12.6875 5.30078 12.6875 5.65625C12.6875 6.03906 12.3867 6.3125 12.0312 6.3125H8.09375C7.71094 6.3125 7.4375 6.03906 7.4375 5.65625V1.71875C7.4375 1.36328 7.71094 1.0625 8.09375 1.0625C8.44922 1.0625 8.75 1.36328 8.75 1.71875V4.09766L12.4414 0.40625C12.6875 0.132812 13.0977 0.132812 13.3711 0.40625C13.6172 0.652344 13.6172 1.0625 13.3711 1.30859ZM0.628906 12.1914L4.32031 8.5H1.96875C1.58594 8.5 1.3125 8.22656 1.3125 7.84375C1.3125 7.48828 1.58594 7.1875 1.96875 7.1875H5.87891C6.26172 7.1875 6.53516 7.48828 6.53516 7.84375V11.7812C6.53516 12.1641 6.26172 12.4375 5.87891 12.4375C5.52344 12.4375 5.22266 12.1641 5.22266 11.7812V9.42969L1.53125 13.1211C1.28516 13.3945 0.875 13.3945 0.628906 13.1211C0.355469 12.875 0.355469 12.4648 0.628906 12.1914Z",
		fill: "#2C2C2C"
	})]
});
const ForwardRef = forwardRef(SvgIconCollapse);
export { ForwardRef as ReactComponent };
